import React, { memo } from 'react';
import styled from 'styled-components';

// import { useDispatch, useSelector } from 'react-redux';

import { Flex, Logo, Section2 } from 'components';
// import { useOffers } from 'features/payments';

import { PaymentsAccount, PaymentsCountries } from 'features/offers';
import { useLocation } from 'react-router-dom';

const HeaderLogo = styled(Logo)`
  ${({ theme: { mediaQueries } }) => {
    return `
    max-height: 22px;

      ${mediaQueries.desktop} {
        max-height: 26px;
      }
    `;
  }}
`;

const Header = memo(() => {
  const { pathname } = useLocation();

  const isSucecss = pathname.search('success') !== -1;

  return (
    <>
      <Section2 flexGrow={0} maxWidth={{ m: '90%', d: 940 }} mt={{ m: 0, d: 6 }} flexDirection="column">
        <Flex justifyContent="space-between" pl={{ m: 2, d: 0 }} bg={{ m: 'white', d: 'transparent' }}>
          <Flex flexGrow={1} flexShrink={0} maxWidth={{ d: 620 }} height={40}>
            <Flex mx={{ m: 'auto', d: 0 }} flexGrow={1} alignItems="center" justifyContent={{ m: 'center', d: 'flex-start' }}>
              <HeaderLogo dark payments />
            </Flex>

            {/* <Flex flexGrow={0} borderRight="1px solid" borderColor="gray_100" display={{ m: 'flex', d: 'none' }} alignItems="center" pr={3}>
              <PaymentsAccount />
              aaa
            </Flex> */}

            {!isSucecss && (
              <Flex display={{ m: 'none', d: 'flex' }} alignItems="center" flexShrink={1} bg="white" flexGrow={0} px={3} borderRadius={4}>
                <PaymentsCountries />
              </Flex>
            )}
          </Flex>

          <Flex
            display={{ m: 'none', d: 'flex' }}
            flexGrow={0}
            flexShrink={0}
            width={{ d: 300 }}
            alignItems="center"
            bg="white"
            borderRadius={4}
            px={3}
          >
            <PaymentsAccount />
          </Flex>
        </Flex>
      </Section2>
    </>
  );
});

export default Header;
